export const TransactionsHistorySorting = {
  ByDate: 'Date',
  ByAmount: 'Amount',
  ByBeneficiaryId: 'BeneficiaryId',
  ByDescription: 'Description',
  None: 'None'
};
